export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const SET_COUNTRY_CODE = "SET_COUNTRY_CODE";
export const SET_ORGANISATION = "SET_ORGANISATION";
export const SET_FIRST_NAME = "SET_FIRST_NAME";
export const SET_LAST_NAME = "SET_LAST_NAME";
export const SET_DATE_OF_BIRTH = "SET_DATE_OF_BIRTH";
export const SET_GRADUATION_YEAR = "SET_GRADUATION_YEAR";
export const SET_FORM_STATUS = "SET_FORM_STATUS";
export const SET_EXTERNAL_FORM_VERIFICATION_URL =
  "SET_EXTERNAL_FORM_VERIFICATION_URL";

export const initialState = {
  loading: true,
  verificationDetails: {},
};

export const toggleLoading = () => ({
  type: TOGGLE_LOADING,
});

export const setCountryCode = (countryCode) => ({
  type: SET_COUNTRY_CODE,
  countryCode,
});

export const setOrganisation = (organisation) => ({
  type: SET_ORGANISATION,
  organisation,
});

export const setFirstName = (firstName) => ({
  type: SET_FIRST_NAME,
  firstName,
});

export const setLastName = (lastName) => ({
  type: SET_LAST_NAME,
  lastName,
});

export const setDateOfBirth = (dateOfBirth) => ({
  type: SET_DATE_OF_BIRTH,
  dateOfBirth,
});

export const setGraduationYear = (graduationYear) => ({
  type: SET_GRADUATION_YEAR,
  graduationYear,
});

export const setFormStatus = (status) => ({
  type: SET_FORM_STATUS,
  status,
});

export const setExternalFormVerificationUrl = (url) => ({
  type: SET_EXTERNAL_FORM_VERIFICATION_URL,
  url,
});

// eslint-disable-next-line complexity
export const verificationDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_LOADING:
      return {
        ...state,
        loading: !state.loading,
      };
    case SET_COUNTRY_CODE:
      return {
        ...state,
        verificationDetails: {
          ...state.verificationDetails,
          countryCode: action.countryCode,
        },
      };
    case SET_ORGANISATION:
      return {
        ...state,
        verificationDetails: {
          ...state.verificationDetails,
          organisation: action.organisation,
        },
      };
    case SET_FIRST_NAME:
      return {
        ...state,
        verificationDetails: {
          ...state.verificationDetails,
          firstName: action.firstName,
        },
      };
    case SET_LAST_NAME:
      return {
        ...state,
        verificationDetails: {
          ...state.verificationDetails,
          lastName: action.lastName,
        },
      };
    case SET_DATE_OF_BIRTH:
      return {
        ...state,
        verificationDetails: {
          ...state.verificationDetails,
          dateOfBirth: { ...action.dateOfBirth },
        },
      };
    case SET_GRADUATION_YEAR:
      return {
        ...state,
        verificationDetails: {
          ...state.verificationDetails,
          graduationYear: action.graduationYear,
        },
      };
    case SET_FORM_STATUS:
      return {
        ...state,
        verificationDetails: {
          ...state.verificationDetails,
          formStatus: action.status,
        },
      };
    case SET_EXTERNAL_FORM_VERIFICATION_URL:
      return {
        ...state,
        verificationDetails: {
          ...state.verificationDetails,
          externalFormVerificationUrl: action.url,
        },
      };
    default:
      return state;
  }
};
